import { z } from 'zod';
import { LocaleDTO } from '../LocaleDTO';
import { SessionActionDTO } from './SessionActionDTO';

export const UserSessionPayloadDTO = z.object({ action: SessionActionDTO }).merge(LocaleDTO);

export type UserSessionPayloadDTO = z.infer<typeof UserSessionPayloadDTO>;
